<template>
    <div id="contactus">
        <!-- ----------------------------問題回報開始---------------------------- -->
        <section class="cm-customercenter-contactus-section">
            <div class="container-fluid p-0">
                <div class="row no-gutters">
                    <div class="col">
                        <img class="img-fluid" :src=imageUrl>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-start justify-content-center mb-4 cm-triangle">
                <div class="cm-triangle-font">
                    {{$t('contactus.ContactUsBar')}}
                </div>
            </div>

            <form>
                <div class="cm-customercenter-contactus-container">
                    <!--
                    過年期間伺服器異常回報
                    <div class="form-group row" v-if="this.serverErrorRepost.isOpen==true">
                        <label class="col col-form-label">{{$t('contactus.QuickReport.ServerError.text1')}}
                            <a class="py-md-3 py-1 cm-customercenter-contactus-serverError" href="#" data-toggle="modal" data-target="#serverErrorQuickReportModal">
                                <u>{{$t('contactus.QuickReport.ServerError.text2')}}</u>
                            </a>
                        </label>
                        <ServerErrorQuickReport :gamesInfo="serverErrorRepost.gamesInfo" :account="loginSubAccount"/>
                    </div>
                    -->
                    
                    <!-- 問題回報案件超過特定篇數將進行提示 -->
                    <div class="form-group" v-if="reportLimitExceededPrompt!=''" v-html="reportLimitExceededPrompt"></div>

                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">{{$t('contactus.Item.Account')}}</label>
                        <div class="input-group-addon d-flex align-items-center col-sm-10">
                            {{loginSubAccount}}
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">{{$t('contactus.Item.QuestionType')}}:</label>
                        <div class="col-sm-10">
                            <select class="form-control form-control-lg cm-customercenter-contactus-select"
                            id="select_questionCategory" v-model="questionCategory">
                                <option value="null">{{$t('contactus.Item.QuestionType')}}</option>
                                <option v-for="question in questions" 
                                :value="question.value" >
                                    {{question.text}}
                                </option>
                            </select>
                            <label class="error" style="color:red" v-if="!correctQuestionType">{{$t('contactus.Item.QuestionType')}}</label>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">{{$t('contactus.Item.Game')}}</label>
                        <div class="col-sm-10">
                            <select class="form-control form-control-lg cm-customercenter-contactus-select"
                            id="select_gameCode" @change="showSeverGroup" v-model="gameCode">
                                <option value="null">{{$t('contactus.Item.Game')}}</option>
                                <option v-for="game in games" 
                                :value="game.gamecode" 
                                :gamepk="game.pk">
                                    {{game.text}}
                                </option>
                            </select>
                            <label class="error" style="color:red" v-if="!correctGame">{{$t('contactus.Item.Game')}}</label>
                        </div>
                    </div>
                    <div class="form-group row"
                    v-show="gameServerGroupShow==true">
                        <label class="col-sm-2 col-form-label">{{$t('contactus.Item.Server1')}}</label>
                        <div class="col-sm-10">
                            <select class="form-control form-control-lg cm-customercenter-contactus-select"
                            id="select_gameServerGroup" @change="showServer" v-model="gameServerGroup">
                                <option value="null">{{$t('contactus.Item.Server1')}}</option>
                                <option v-for="group in servergroup" 
                                :value="group.num" 
                                :serevrgroupid="group.id">
                                    {{group.text}}
                                </option>
                            </select>
                            <label class="error" style="color:red" v-if="!correctServer1">{{$t('contactus.Item.Server1')}}</label>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">{{$t('contactus.Item.Server2')}}</label>
                        <div class="col-sm-10">
                            <select class="form-control form-control-lg cm-customercenter-contactus-select"
                            id="select_gameServer" v-model="gameServer">
                                <option value="null">{{$t('contactus.Item.Server2')}}</option>
                                <option v-for="server in servers" 
                                :value="server.num" 
                                :serverpk="server.pk">
                                    {{server.text}}
                                </option>
                            </select>
                            <label class="error" style="color:red" v-if="!correctServer2">{{$t('contactus.Item.Server2')}}</label>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">{{$t('contactus.Item.Character')}}</label>
                        <div class="col-sm-10">
                            <input type="text" 
                            v-model="CharacterName"
                            class="form-control-plaintext cm-customercenter-contactus-input">
                            <label class="error" style="color:red" v-if="!correctCharacterNameLen">{{$t('contactus.Item.Character.Prompt.Input.maxLen')}}</label>
                            <label class="error" style="color:red" v-if="!correctCharacterNameSpecialSymbols">{{$t('contactus.Item.Character.Prompt.Input.specialSymbols')}}</label>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">{{$t('contactus.Item.Email')}}</label>
                        <div class="col-sm-10">
                            <input type="mail" 
                            v-model="Email"
                            class="form-control-plaintext cm-customercenter-contactus-input">
                            <label class="error" style="color:red" v-if="!correctEmail">{{$t('contactus.Item.Email')}}</label>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">{{$t('contactus.Item.MobilePhone')}}</label>
                        <div class="col-sm-10 row no-gutters">
                            <input type="tel" v-model="PhoneFront"
                            class="cm-customercenter-contactus-input col-2" placeholder="+886"/>
                            <input type="tel" v-model="Phone" 
                            class="cm-customercenter-contactus-input offset-1 col-9 col-sm-7" />
                            <label class="w-100 error" style="color:red" v-if="!correctPhone">{{$t(PhonePromptString)}}</label>
                            <span class="cm-customercenter-contactus-promptColor">
                                {{$t('contactus.Item.MobilePhone.Prompt')}}
                            </span>
                        </div>
                    </div>
                    <!-- 2020/10/12對應新的客服頁面，主題欄位不再顯示
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">{{$t('contactus.Item.Title')}}</label>
                        <div class="col-sm-10">
                            <input type="text" 
                            v-model="Title"
                            class="form-control-plaintext cm-customercenter-contactus-input">
                            <label class="error" style="color:red" v-if="!correctTitleLen">{{$t('contactus.Item.Title.Prompt.Input.maxLen')}}</label>
                            <label class="error" style="color:red" v-if="!correctTitleReq">{{$t('contactus.Item.Title.Prompt.Input.req')}}</label>
                            <label class="error" style="color:red" v-if="!correctTitleSpecialSymbols">{{$t('contactus.Item.Title.Prompt.Input.specialSymbols')}}</label>
                        </div>
                    </div>
                    -->
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">{{$t('contactus.Item.Content')}}</label>
                        <div class="col-sm-10">
                            <textarea v-model="Content" class="form-control rounded-0" rows="5"></textarea>
                            <label class="error" style="color:red" v-if="!correctContentReq">{{$t('contactus.Item.Content.Prompt.Input.req')}}</label>
                            <label class="error" style="color:red" v-if="!correctContentSpecialSymbols">{{$t('contactus.Item.Content.Prompt.Input.specialSymbols')}}</label>
                            <br />
                            <div class="d-flex justify-content-start">
                                <a @click="addImg" class="cm-customercenter-contactus-uploadImg-btn">{{$t('contactus.Button.Screenshot')}}</a>
                            </div>
                            <label class="error" style="color:red" v-if="Imglimit">{{$t('contactus.Button.Screenshot.Max')}}</label>

                            <span class="cm-customercenter-contactus-promptColor">
                                {{$t('contactus.Button.Screenshot.Prompt')}}
                            </span>
                            <ul id="uploadImagesList" style="padding: 0 0 0 0;">
                                <li v-for="(img,index) in ImgList" class="row" :key="img.id">
                                    <label class="col-sm-10" style="padding: 0 0 0 0;">
                                        <input type="file" 
                                        :id="'IMG'+img.id"
                                        class="col-sm-6 imageDummy" 
                                        style="padding: 0 0 0 0;" 
                                        @change="ImgCheck($event,img.id,index)"
                                        accept="image/jpeg,image/jpg,image/png,image/bmp"/>
                                    </label>
                                    <a class="col-sm-2 cm-customercenter-contactus-uploadImg-btn" 
                                    @click="delImg(index)">
                                        {{img.del}}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>


                    <div class="d-flex justify-content-center">
                    <div class="spinner-border text-light" id="Loading" role="status" style="display:none"> 
                        <span class="sr-only">Loading...</span>
                    </div>
                        <a @click.prevent="submitForm" id="submitComplaint" class="cm-customercenter-contactus-send-btn" href="#">{{$t('contactus.Button.Confirm')}}</a>
                    </div>

                    <!-- ----------------------------提問資訊開始---------------------------- -->
                    <div class="modal fade cm-modal-contactus" id="contactusModal" tabindex="-1" role="dialog" aria-labelledby="contactusModalTitle" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content">
                                <div class="modal-header align-middle cm-contactus-header">
                                    <h4 class='col-12 modal-title text-center text-white'>
                                        {{$t('contactus.response.Title')}}
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" onclick="window.location.href = '/#/historylist'">
                                            <span aria-hidden="true"><img src="@/assets/images/login-close.png" alt=""
                                                    class="cm-contactus-close"></span>
                                        </button>
                                    </h4>
                                </div>
                                <div class="modal-body">
                                    <div class="border border-secondary m-2 pb-3">
                                        <div class="row-fluid py-3">
                                            <div class="col text-center" style="color:black">
                                                {{$t('contactus.response.TicketNumber')}}: {{TicketNumber}}
                                            </div>
                                        </div>
                                        <div class="row-fluid py-3">
                                            <div class="col text-center" style="color:black">
                                                {{$t('contactus.response.InquiryTime')}}: {{InquiryTime}}
                                            </div>
                                        </div>
                                        <!-- 2020/10/12對應新的客服頁面，主題欄位不再顯示
                                        <div class="row-fluid py-3">
                                            <div class="col text-center text-light bg-secondary py-1" style="color:black">
                                                {{$t('contactus.Item.Title')}} : {{Title}}
                                            </div>
                                        </div>
                                        -->
                                        <div class="row-fluid py-3">
                                            <div class="col text-center" style="color:black">
                                                {{$t('contactus.response.Content')}}
                                            </div>
                                        </div>
                                        <div class="row-fluid py-3">
                                            <div class="col text-center" style="color:black">
                                                {{$t('contactus.response.Tnanks')}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ----------------------------提問資訊結束---------------------------- -->
                </div>
            </form>
            
            <br/>
            <div class="cm-customercenter-contactus-banner-line"></div>
        </section>
        <!-- ----------------------------問題回報結束---------------------------- -->
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import CookieUtil from "@/assets/js/util/CookieUtil.js";
import ValidatorUtil from "@/assets/js/util/ValidatorUtil.js";
import eventBus from '@/assets/js/event/EventBus.js';
import store from '@/store/store-controller/store.js';
import ShowMsg from "@/assets/js/util/ShowMsg.js";
import router from '@/router.js'
import * as BackendSetting from "@/assets/js/util/BackendSetting.js";

// 過年期間伺服器異常回報
//import ServerErrorQuickReport from "@/components/modal/ServerErrorQuickReport.vue";

var DepositResultJson;
var count = 0;
var BrowserDetect = {
	init: function () {
		this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
		this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "an unknown version";
		this.OS = this.searchString(this.dataOS) || "an unknown OS";
	},
	searchString: function (data) {
		for (var i=0;i<data.length;i++)	{
			var dataString = data[i].string;
			var dataProp = data[i].prop;
			this.versionSearchString = data[i].versionSearch || data[i].identity;
			if (dataString) {
				if (dataString.indexOf(data[i].subString) != -1)
					return data[i].identity;
			} else if (dataProp)
				return data[i].identity;
			}
		},
	searchVersion: function (dataString) {
		var index = dataString.indexOf(this.versionSearchString);
		if (index == -1) return;
		return parseFloat(dataString.substring(index+this.versionSearchString.length+1));
	},
	dataBrowser: [
		{
			string: navigator.userAgent,
			subString: "Chrome",
			identity: "Chrome"
		},
		{ 	string: navigator.userAgent,
			subString: "OmniWeb",
			versionSearch: "OmniWeb/",
			identity: "OmniWeb"
		},
		{
			string: navigator.vendor,
			subString: "Apple",
			identity: "Safari",
			versionSearch: "Version"
		},
		{
			prop: window.opera,
			identity: "Opera",
			versionSearch: "Version"
		},
		{
			string: navigator.vendor,
			subString: "iCab",
			identity: "iCab"
		},
		{
			string: navigator.vendor,
			subString: "KDE",
			identity: "Konqueror"
		},
		{
			string: navigator.userAgent,
			subString: "Firefox",
			identity: "Firefox"
		},
		{
			string: navigator.vendor,
			subString: "Camino",
			identity: "Camino"
		},
		{	// for newer Netscapes (6+)
			string: navigator.userAgent,
			subString: "Netscape",
			identity: "Netscape"
		},
		{
			string: navigator.userAgent,
			subString: "MSIE",
			identity: "Explorer",
			versionSearch: "MSIE"
		},
		{
			string: navigator.userAgent,
			subString: "Gecko",
			identity: "Mozilla",
			versionSearch: "rv"
		},
		{ 	// for older Netscapes (4-)
			string: navigator.userAgent,
			subString: "Mozilla",
			identity: "Netscape",
			versionSearch: "Mozilla"
		}
	],
	dataOS : [
		{
			string: navigator.platform,
			subString: "Win",
			identity: "Windows"
		},
		{
			string: navigator.platform,
			subString: "Mac",
			identity: "Mac"
		},
		{
		   string: navigator.userAgent,
		   subString: "iPhone",
		   identity: "iPhone/iPod"
	    },
		{
			string: navigator.platform,
			subString: "Linux",
			identity: "Linux"
		}
	]
};
var chartbot_gamecode;
var chartbot_sid;
var chartbot_title;
var chartbot_category;
var asyncTry;

export default {
    /*
    // 過年期間伺服器異常回報
    components: {
        ServerErrorQuickReport
    },
    */
    data() {
        return {
            loginAccount: "",
            loginSubAccount: "",
            games: [],
            servergroup: [],
            servers: [],
            questions: [],
            correctCharacterNameLen: true,
            correctCharacterNameSpecialSymbols: true,
            correctEmail: true,
            correctPhone: true,
            correctTitleLen: true,
            correctTitleReq: true,
            correctTitleSpecialSymbols: true,
            correctContentReq: true,
            correctContentSpecialSymbols: true,
            correctQuestionType: true,
            correctGame: true,
            correctServer1: true,
            correctServer2: true,
            gameServerGroupShow: true,
            questionCategory: "null",
            gameCode: "null",
            gameServerGroup: "null",
            gameServer: "null",
            Email: "",
            PhoneFront: "",
            Phone: "",
            PhonePromptString: "",
            Title: "no_all9fun",
            Content: "",
            Imglimit: false,
            ImgList: [],
            CharacterName: "",
            ModalBtnText: "我知道了",
            uploadImgList: [],
            num: "",
            Fk: "",
            Pk: "",
            TicketNumber: "",
            InquiryTime: "",
            reportUnfinishedLimit: 3, // 限制已回報案件但未完成的數量
            reportLimitExceededPrompt: "", // 回報案件數量超出限制，要做提示
            imageUrlDefault: require("@/assets/images/game/gametitle.jpg"),
            imageUrl: require("@/assets/images/game/gametitle.jpg"),
            serverErrorRepost: {
                gamesInfo: "",
                isOpen: false
            },
            autoSelectFromUrl: {
                isAutoSelect: false,
                gameCode: null,
            },
        }
    },
    mounted() {
        this.updateTopBackgroundImg();

        // 是否開啟伺服器異常回報
        let nowTs = new Date().getTime()
        if(process.env.VUE_APP_SERVER_ERROR_REPORT_START_TIMESTAMP<=nowTs
            && nowTs<=process.env.VUE_APP_SERVER_ERROR_REPORT_END_TIMESTAMP) {
            this.serverErrorRepost.isOpen = true;
        }
        //
        // 更換語言時
        const self = this;
        if(eventBus["_events"][process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_CONTACT_US] !== undefined) {
            delete eventBus["_events"][process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_CONTACT_US]
        }
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_CONTACT_US, function(i18n) {
            self.setInitData();
            self.updateTopBackgroundImg(i18n);

            // url有gameCode參數
            if(self.$route.query.gameCode !== undefined) {
                self.autoSelectFromUrl.isAutoSelect = true
                self.autoSelectFromUrl.gameCode = self.$route.query.gameCode
            }
        });

        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_SWITCH_PAGE_SHOW_ITEMS , false);

        // 驗證是否為登入狀態，未登入狀態則顯示loginModal讓玩家登入，玩家登入完畢後再回來
        let verifySetting = {
            verifyStatus: true, // 驗證登入
            from: router.currentRoute.name, // 來源頁面
            setFrontendRouterPushCookie: true, // 是否設置cookie方便登入會導回from設置的頁面
            showLoginModal: true, // 未登入狀態下顯示loginModal
            setCookie: {}
        };
        
        // 判斷是否有gameCode，代表後續要自動代入遊戲
        if(this.$route.query.gameCode !== undefined) { // url有gameCode參數
            this.autoSelectFromUrl.isAutoSelect = true
            this.autoSelectFromUrl.gameCode = this.$route.query.gameCode
            verifySetting.setCookie[process.env.VUE_APP_COOKIE_CONTACTUS_AUTOSELECT_GAMECODE] = this.$route.query.gameCode
        }
        else if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_CONTACTUS_AUTOSELECT_GAMECODE)!==false) {  // cookie有gameCode參數
            this.autoSelectFromUrl.isAutoSelect = true
            this.autoSelectFromUrl.gameCode = CookieUtil.getCookie(process.env.VUE_APP_COOKIE_CONTACTUS_AUTOSELECT_GAMECODE)
            CookieUtil.commonDeleteCookie(process.env.VUE_APP_COOKIE_CONTACTUS_AUTOSELECT_GAMECODE);
        }
        
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_VERIFY_LOGIN, verifySetting);
    },
    methods: {
        getMem()
        {
            if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE)!==false)
            {
                this.insertActionDOM();
                chartbot_gamecode = this.$route.query.gamecode;
                chartbot_sid = this.$route.query.sid;
                chartbot_title = this.$route.query.title;
                chartbot_category = this.$route.query.category;

                if(chartbot_title!=undefined && chartbot_title!='')
                {
                    this.Title = chartbot_title;
                }
            }
        },
        async insertActionDOM()
        {
            if(document.querySelectorAll("head script[src='" + 
            process.env.VUE_APP_URL_DOMAIN_LOGIN + "/initMdepositJsonAction.shtml?paymentStatus=3" +
            "']").length <= 0)
            {
                let redirectDepositPage = document.createElement("script");
                redirectDepositPage.setAttribute("src", process.env.VUE_APP_URL_DOMAIN_LOGIN + "/initMdepositJsonAction.shtml?paymentStatus=3");
                document.head.appendChild(redirectDepositPage);
            }
            await this.checkInitData();
        },
        checkInitData()
        {
            let self = this;
            let count = 0;
            let waitSecond = 1000;
            let limitN = process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND / waitSecond;
            asyncTry = setInterval(function(){
                try {
                    if(remoteDepositInfo) { 
                        self.Email = remoteDepositInfo.getMail();
                        self.setInitData();
                    }
                }
                catch(e) {}
                if(count >= limitN )
                {
                    clearInterval(asyncTry);
                    alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                    return;
                }
                count ++;
            },waitSecond);
        },
        setInitData()
        {
            try{
                clearInterval(asyncTry);
                DepositResultJson = JSON.parse(remoteDepositInfo.getGameServer());
                this.serverErrorRepost.gamesInfo = DepositResultJson;
                this.Fk = JSON.parse(remoteDepositInfo.getFk());
                this.Pk = JSON.parse(remoteDepositInfo.getPk());
                this.loginSubAccount = remoteDepositInfo.getSubAccount();
                if(DepositResultJson === '')
                {
                    alert(this.$i18n.t('common.PleaseLogin'));
                    router.push({name: process.env.VUE_APP_ROUTER_HOME});
                }
                else
                {
                    BrowserDetect.init();
                    this.getMemberData();
                }
            }
            catch(err)
            {
                if(router.currentRoute.name == process.env.VUE_APP_ROUTER_CONTACT_US) {
                    console.log(err);
                    alert(this.$i18n.t('common.PleaseLogin'));
                }
                router.push({name: process.env.VUE_APP_ROUTER_HOME});
            }
        },
        async getMemberData()
        {
            // 取得CustomerComplaintData
            const customerComplaintData = await this.ajaxGetCustomerComplaintDataAction()
            
            // 依照CustomerComplaintData進行處理
            if(customerComplaintData!=null && customerComplaintData.status!=undefined && customerComplaintData.status=='success') {
                if(this.showReportLimitExceededPromptByUnfinishedCount(customerComplaintData.unfinishedCount) == false) {
                    this.loginAccount = customerComplaintData.Account;
                    if(this.loginAccount == undefined) {
                        this.loginAccount = '';
                    }
                    this.num = customerComplaintData.num;
                    for(var key in customerComplaintData.questionCategory) {
                        this.questions.push({
                            value: key,
                            text: customerComplaintData.questionCategory[key]
                        })
                    }

                    this.$nextTick(function () {
                        if(chartbot_category!=undefined && chartbot_category!='') {
                            this.questionCategory = chartbot_category;
                        }
                    });
                    this.showGames();
                }
            }
        },
        async updateTopBackgroundImg(i18n = this.$i18n) {
            // 更新上方背景圖
            let imageUrl = await BackendSetting.getTopBackgroundImgUrl(i18n.locale);
            this.imageUrl = (imageUrl != "" ? imageUrl : this.imageUrlDefault);
        },
        clear()
        {
            this.servergroup = [];
            this.servers = [];
            this.gameServerGroup = 'null';
            this.gameServer = 'null';
        },
        initAutoSelectFromUrl(num) {
            if(num >= 100) {
                this.autoSelectFromUrl.isAutoSelect = false
            }
            if(num >= 1) {
                this.autoSelectFromUrl.gameCode = null
            }
        },
        showGames()//變更遊戲
        {            
            this.games = [];
            this.clear();
            for(var obj in DepositResultJson)
            {
                if(DepositResultJson.hasOwnProperty(obj))
                {
                    this.games.push({
                        gamecode: obj,
                        pk: DepositResultJson[obj]['gamePk'],
                        text: DepositResultJson[obj]['gameName']
                    });
                }
            }
            this.$nextTick(function () {
                if(chartbot_gamecode!=undefined && chartbot_gamecode!='')
                {
                    this.gameCode = chartbot_gamecode;
                    this.showSeverGroup();
                }
                else if(this.autoSelectFromUrl.isAutoSelect==true && this.autoSelectFromUrl.gameCode!=null) {
                    let isGameCodeExist = false
                    for(let i=0; i<this.games.length; i++) {
                        const game = this.games[i]
                        if(game.gamecode == this.autoSelectFromUrl.gameCode) {
                            isGameCodeExist = true
                            break
                        }
                    }
                    if(isGameCodeExist) {
                        this.gameCode = this.autoSelectFromUrl.gameCode;
                        this.showSeverGroup();
                    }
                    this.initAutoSelectFromUrl(100)
                }
            });
        },
        showSeverGroup()//變更遊戲伺服器分區
        {            
            if(this.gameCode != 'null' && this.gameCode != '')
            {
                this.clear();
                for(var obj in DepositResultJson[this.gameCode]['serverGroups'])
                {                
                    if(DepositResultJson[this.gameCode]['serverGroups'].hasOwnProperty(obj))
                    {                            
                        this.servergroup.push({
                            num: obj,
                            id: DepositResultJson[this.gameCode]['serverGroups'][obj]['serverGroupId'],
                            text: DepositResultJson[this.gameCode]['serverGroups'][obj]['serverGroupName']
                        });
                    } 
                }

                if(this.servergroup.length == 1)
                {
                    this.gameServerGroupShow = false;
                    this.gameServerGroup = this.servergroup[0].num;
                }
                else
                {
                     this.gameServerGroupShow = true;
                }

                this.$nextTick(function () {
                    if(chartbot_sid!=undefined && chartbot_sid!='')
                    {
                        for(var groups in DepositResultJson[this.gameCode]['serverGroups'])
                        {
                            for(var server in DepositResultJson[this.gameCode]['serverGroups'][groups]['server'])
                            {
                                if(DepositResultJson[this.gameCode]['serverGroups'][groups]['server'][server]['gameServerNum']==chartbot_sid)
                                {
                                    this.gameServerGroup = groups;
                                    this.showServer();
                                    this.$nextTick(function () {
                                        this.gameServer = chartbot_sid;
                                    });
                                }
                            }    
                        }
                    }
                    else(this.gameServerGroup != 'null' && this.gameServerGroup != '')
                    {
                        this.showServer();
                    }
                });
            }
        },
        showServer()//變更遊戲伺服器
        {
            this.servers = [];
            this.gameServer = 'null';
            if(this.gameServerGroup!=null && this.gameServerGroup!=undefined && this.gameServerGroup!="null") {
                for(var obj in DepositResultJson[this.gameCode]['serverGroups'][this.gameServerGroup]['server'])
                {
                    if(DepositResultJson[this.gameCode]['serverGroups'][this.gameServerGroup]['server'].hasOwnProperty(obj))
                    {        
                        this.servers.push({
                            num: DepositResultJson[this.gameCode]['serverGroups'][this.gameServerGroup]['server'][obj]['gameServerNum'],
                            pk: DepositResultJson[this.gameCode]['serverGroups'][this.gameServerGroup]['server'][obj]['serverPk'],
                            text: DepositResultJson[this.gameCode]['serverGroups'][this.gameServerGroup]['server'][obj]['gameServerName']
                        });             
                    } 
                }
            }
        },
        addImg()
        {
            if(3 <= this.ImgList.length) {
                this.Imglimit = true;
                return;
            }
		
            this.uploadImgList.push("");
            this.ImgList.push({
                text:'上傳圖片',
                id: count,
                del:'刪除'
            });
            count++;
        },
        delImg(index)
        {
            this.ImgList.splice(index,1);
            this.uploadImgList.splice(index,1);
        },
        ImgCheck(e,id,index)
        {
            let file = e.target.files[0];
            var name = file.name;
            var size = file.size;
            var type = file.type;
            
            if(size > 1024 * 1024 * 5) {
                alert('上傳檔案超過限制大小');
                $('#IMG'+id).val("");
                return;
            } else if(type != 'image/png' && type != 'image/jpg'
                && type != 'image/bmp' && type != 'image/jpeg') {
                alert("檔案僅限副檔名為：" + 'JPG/PNG/BMP');
                $('#IMG'+id).val("");
                return;
            }
            this.uploadImgList.splice(index,1,name);
        },
        async submitForm()
        {
            // 檢查是否超過回報案件篇數
            const reportLimitExceededPromptIsOpen = (this.reportLimitExceededPrompt == "" ? false : true)
            const customerComplaintData = await this.ajaxGetCustomerComplaintDataAction()
            if(customerComplaintData==null || customerComplaintData.status==undefined || customerComplaintData.status!='success') {
                return
            }
            else {
                const isShowReportLimitExceededPrompt = this.showReportLimitExceededPromptByUnfinishedCount(customerComplaintData.unfinishedCount)
                if(isShowReportLimitExceededPrompt == true) {
                    return
                }
                else {
                    if(reportLimitExceededPromptIsOpen == true) {
                        location.reload()
                        return
                    }
                }
            }

            if(this.questionCategory == "null")
            {
                this.correctQuestionType = false;
            }
            else
            {
                this.correctQuestionType = true;
            }
            if(this.gameCode == "null")
            {
                this.correctGame = false;
            }
            else
            {
                this.correctGame = true;
            }
            if(this.gameServerGroup == "null")
            {
                this.correctServer1 = false;
            }
            else
            {
                this.correctServer1 = true;
            }
            if(this.gameServerGroup == "null")
            {
                this.correctServer1 = false;
            }
            else
            {
                this.correctServer1 = true;
            }
            if(this.gameServer == "null")
            {
                this.correctServer2 = false;
            }
            else
            {
                this.correctServer2 = true;
            }
            if(this.CharacterName.length > 20) // 如果有填角色名稱，則需小於20字元
            {
              this.correctCharacterNameLen = false;
              this.correctCharacterNameSpecialSymbols = true;
            }
            else if(ValidatorUtil.isStringHaveUTF8MoreThen3BytesChar(this.CharacterName))
            {
              this.correctCharacterNameLen = true;
              this.correctCharacterNameSpecialSymbols = false;
            }
            else
            {
              this.correctCharacterNameLen = true;
              this.correctCharacterNameSpecialSymbols = true;
            }
            if(this.Email.length < 1 
            || ValidatorUtil.validEmail(this.Email,{ 'req': "Please enter email", "format": "Invalid Email format" })!='')
            {
              this.correctEmail = false;
            }
            else
            {
                this.correctEmail = true;
            }
            
            // 驗證手機號碼
            var phoneNumber = "";
            if(this.PhoneFront=="" && this.Phone=="") { // 國碼&手機號碼不填寫
                this.correctPhone = true;
            }
            else {
                var vaildPhoneErrorString = {
                    "countryCodeFormat": "contactus.Item.MobilePhone.Validate.CountryCode.format",
                    "countryCodePlus": "contactus.Item.MobilePhone.Validate.CountryCode.plus",
                    "countryCodeReq": "contactus.Item.MobilePhone.Validate.CountryCode.req",
                    "phoneNum": "contactus.Item.MobilePhone.Validate.Phone.num",
                    "phoneReq": "contactus.Item.MobilePhone.Validate.Phone.req",
                    "phoneTwPhoneFormat": "contactus.Item.MobilePhone.Validate.Phone.twPhoneFormat",
                    "phoneTwPhoneFirstDigitalNine": "contactus.Item.MobilePhone.Validate.Phone.twPhoneFirstDigitalNine",
                }
                this.PhonePromptString = ValidatorUtil.vaildPhone(this.PhoneFront, this.Phone, vaildPhoneErrorString);
                if(this.PhonePromptString == "") {
                    phoneNumber = this.PhoneFront  + "-" + this.Phone;
                    this.correctPhone = true;
                }
                else {
                    this.correctPhone = false;
                }
            }
            // 主題字數檢查
            if(this.Title.length < 1)
            {
                this.correctTitleLen = true;
                this.correctTitleReq = false;
                this.correctTitleSpecialSymbols = true;
            }
            else if(this.Title.length > 20)
            {
                this.correctTitleLen = false;
                this.correctTitleReq = true;
                this.correctTitleSpecialSymbols = true;
            }
            else if(ValidatorUtil.isStringHaveUTF8MoreThen3BytesChar(this.Title))
            {
                this.correctTitleLen = true;
                this.correctTitleReq = true;
                this.correctTitleSpecialSymbols = false;
            }
            else
            {
                this.correctTitleLen = true;
                this.correctTitleReq = true;
                this.correctTitleSpecialSymbols = true;
            }
            if(this.Content.length < 1)
            {
                this.correctContentReq = false;
                this.correctContentSpecialSymbols = true;
            }
            else if(ValidatorUtil.isStringHaveUTF8MoreThen3BytesChar(this.Content))
            {
                this.correctContentReq = true;
                this.correctContentSpecialSymbols = false;
            }
            else
            {
                this.correctContentReq = true;
                this.correctContentSpecialSymbols = true;
            }
            
            var uploadImgListString = [];
            for(var i in this.uploadImgList)
            {
                if(this.uploadImgList[i]!="")
                {
                    uploadImgListString.push(this.uploadImgList[i])
                }
            } 
            
            this.$nextTick(function () {
                if($('.error').length > 0 
                || this.Email == ''
                || this.Title == ''
                || this.Content == ''
                || this.gameCode == 'null' 
                || this.gameServerGroup == 'null'
                || this.gameServer == 'null'
                || this.questionCategory == 'null'
                )
                {
                    document.documentElement.scrollTop = 100;
                }
                else
                {
                    this.showLoading();
                    let self = this;

                    let bodyFormData = new FormData();					
                    bodyFormData.append("customerComplaint.fkGameManufactory", $('#select_gameCode :selected').attr('gamepk'));
                    bodyFormData.append("gameServerGroup", this.gameServerGroup);
                    bodyFormData.append("customerComplaint.gameServerNum", this.gameServer);
                    bodyFormData.append("customerComplaint.fkGameServer", $('#select_gameServer :selected').attr('serverpk'));
                    bodyFormData.append("customerComplaint.fkMemberMultiId", this.Pk);
                    bodyFormData.append("dopictureFileNameSet", JSON.stringify(uploadImgListString));
                    bodyFormData.append("customerComplaint.createUser", this.loginSubAccount);
                    bodyFormData.append("checkMember", this.num);
                    bodyFormData.append("num", this.Pk);
                    bodyFormData.append("customerComplaint.gameCode", this.gameCode);
                    bodyFormData.append("questionReportKey", CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE));
                    bodyFormData.append("customerComplaint.subAccount", this.loginSubAccount);
                    bodyFormData.append("customerComplaint.gameCharacterName", this.CharacterName);
                    bodyFormData.append("customerComplaint.questionCategory", this.questionCategory);
                    bodyFormData.append("customerComplaint.questionTitle", this.Title);
                    bodyFormData.append("customerComplaint.browserName", BrowserDetect.browser + BrowserDetect.version);
                    bodyFormData.append("customerComplaint.questionDescription", this.Content);
                    bodyFormData.append("customerComplaint.mobilePhone", phoneNumber);
                    bodyFormData.append("customerComplaint.mainEmail", this.Email);
                    bodyFormData.append("customerComplaint.account", this.loginAccount);
                    bodyFormData.append("customerComplaint.languageCode", this.$i18n.locale.replace("-", "_"));

                    axios({
                        method: "post",
                        url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/RegistratCustomerComplaintAction.shtml",
                        data: bodyFormData,
                        config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                    })
                    .then(function(response) {
                        //送出成功
                        var data = response.data;
                        if(data.result=="SUCCESS") {
                            self.TicketNumber = data.orderId;
                            self.InquiryTime = data.customerComplaint.applyConvertDate;
                            
                            //上傳圖片功能
                            self.uploadImages(data.resultNum,data.savepictureFileNameSetGroupList);

                            // console.log("self.ImgList.length:"+self.ImgList.length)
                            //延遲，讓其可有充裕時間上傳圖片
                            if(self.ImgList.length > 0)
                            {
                                setTimeout(function() {
                                    self.hideLoading();
                                    console.log("有圖片、送出成功");
                                    
                                    //防止按下esc或頁面外時，modal消失的狀況
                                    $('#contactusModal').modal({
                                        keyboard: false,
                                        backdrop: false
                                    });
                                    $('#contactusModal').modal('show');
                                }, self.ImgList.length * 3000);
                            }	
                            else
                            {
                                self.hideLoading();
                                console.log("沒有圖片、送出成功");
                                //防止按下esc或頁面外時，modal消失的狀況
                                $('#contactusModal').modal({
                                    keyboard: false,
                                    backdrop: false
                                });
                                $('#contactusModal').modal('show');
                            }
                        }
                        //送出失敗
                        else
                        {                            
                            self.hideLoading();
                            console.log("送出失敗");
                            $('#showMsgModalText').html(self.$i18n.t('contactus.response.Fail'));
                            $("#showMsgModalText").css("text-align","center");
                            //防止按下esc或頁面外時，modal消失的狀況
                            $('#showMsgModal').modal({
                                keyboard: false,
                                backdrop: false
                            });
                            $('#MsgButton').attr('onclick',"window.location.href='/#/contactus'");
                            $('#showMsgModal').modal('show');
                        }
                    })
                    .catch(function (e) {
                        alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                        console.log(e);
                    });
                }
            });
        },
        showLoading() {
            $('#Loading').show();
            $('#submitComplaint').hide();
        },
        hideLoading(){
            $('#Loading').hide();
            $('#submitComplaint').show();
        },
        uploadImages(resultNum,savepictureFileNameSetGroupList)
        {
            const self = this;
            $(".imageDummy").each(function() {
                if(null == this.value || '' == this.value) {
                    // do nothing
                } else {
                    var objXhr = new XMLHttpRequest();
                    objXhr.open('POST', process.env.VUE_APP_URL_DOMAIN_LOGIN + '/all9FunUploadImage.shtml');
                    var objForm = new FormData() ;
                    objForm.append('upload', this.files[0]) ;
                    objForm.append('csUploadID', resultNum);
                    objForm.append('csUploadIMG', JSON.stringify(savepictureFileNameSetGroupList));
                    objForm.append('imageUploadKey', CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE));
                    objForm.append('imageUploadFrom', location.protocol + "//" + location.host);
                    objForm.append('mutiNum', self.Pk);
                    objXhr.send(objForm);
                }
            });
        },
        showReportLimitExceededPromptByUnfinishedCount(unfinishedCount) {
            let isShowPrompt = false
            // 未處理案件大於等於限制篇數，顯示提示
            if(unfinishedCount >= this.reportUnfinishedLimit) {
                isShowPrompt = true
                const text = this.$i18n.t('contactus.report.unfinishedCount.text1')
                let replacedStr = text.replace(/「(.*?)」/, '<a href=\'#/historylist\' onclick=\'document.querySelector("#MsgButton").click()\'>$&</a>');
                this.reportLimitExceededPrompt = replacedStr.replace("「link」", this.$i18n.t('contactus.report.unfinishedCount.text2'))
                ShowMsg.showModal(this.reportLimitExceededPrompt)
            }
            else {
                this.reportLimitExceededPrompt = ""
            }
            return isShowPrompt
        },
        async isReportExceededLimit_bk() {
            let isExceededLimit = false
            let lang = store.getters['storeI18n/getNowLanguage']
            if(lang.includes('en')) {
                lang = 'en'
            }
            let bodyFormData = new FormData();
            if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE)!=false) {
                bodyFormData.append("allMemberMultiIdKey", CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE));
                bodyFormData.append("mainPk", this.Fk);
                bodyFormData.append("num", this.Pk);
                bodyFormData.append("language", lang)
                const resp = await axios({
                    method: "post",
                    url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/getCustomerComplaintDataAction.shtml",
                    data: bodyFormData,
                    timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                    config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                })

                if(resp.data.status == "success") {
                    const data = resp.data;
                    if(data.unfinishedCount >= this.reportUnfinishedLimit) {
                        isExceededLimit = true
                        this.showReportLimitExceededPrompt()
                    }
                }
            }
            return isExceededLimit
        },

        /**
         * 取得CustomerComplaintData，過程若有失敗則跳出提示
         */
        async ajaxGetCustomerComplaintDataAction() {
            // 欲return資料
            let customerComplaintData = null
            
            // cookie
            const allMemberMultiIdKey = CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE)

            if(allMemberMultiIdKey==false) { // 沒有cookie，提示要登入
                alert(this.$i18n.t('common.PleaseLogin'));
                router.push({name: process.env.VUE_APP_ROUTER_HOME});
            }
            else {
                let respData = null
                try {
                    // 取得語言
                    let lang = store.getters['storeI18n/getNowLanguage']
                    if(lang.includes('en')) {lang = 'en'}

                    // 準備request使用的資料
                    let bodyFormData = new FormData();
                    bodyFormData.append("allMemberMultiIdKey", allMemberMultiIdKey);
                    bodyFormData.append("mainPk", this.Fk);
                    bodyFormData.append("num", this.Pk);
                    bodyFormData.append("language", lang)

                    // request & response
                    const resp = await axios({
                        method: "post",
                        url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/getCustomerComplaintDataAction.shtml",
                        data: bodyFormData,
                        timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                        config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                    })
                    respData = resp.data
                }
                catch(e) {}

                if(respData==null || respData.status == undefined) {
                    alert(this.$i18n.t('common.Backend.Response.ConnectionFailed'));
                }
                else if(respData.status == 'success') { // 成功
                    customerComplaintData = respData
                }
                else {
                    alert(this.$i18n.t('common.Backend.Response.ConnectionFailed'));
                }
            }
            return customerComplaintData
        },
    },
    created() {
        this.getMem();
    },
}
</script>